import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from '@app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import {
  initMainScriptRecovery,
  initDeploymentVersionCheck,
} from '@utilities/deploymentUpdate';

import { AppThemeProvider, hydrateThemeFromStorage } from './theme/index';
import './index.scss';

hydrateThemeFromStorage();
initMainScriptRecovery();
initDeploymentVersionCheck();

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppThemeProvider>
        <App />
      </AppThemeProvider>
    </Provider>
  </React.StrictMode>
);

serviceWorkerRegistration.register();

reportWebVitals();
